
import $ from "jquery";
import _ from "underscore";

function invalidateInput(inputEl){

}

export function showModal(modalEL){
    modalEL.show();

    modalEL.find('.modal-bg').removeClass("ease-in duration-200 opacity-0");
    modalEL.find('.modal-bg').addClass("ease-out duration-300 opacity-100");

    modalEL.find('.modal-panel').removeClass("ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95");
    modalEL.find('.modal-panel').addClass("ease-out duration-300 opacity-100 translate-y-0 sm:scale-100");
}

export function closeModal(modalEL){
    modalEL.find('.modal-bg').addClass("ease-in duration-200 opacity-0");
    modalEL.find('.modal-bg').removeClass("ease-out duration-300 opacity-100");

    modalEL.find('.modal-panel').addClass("ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95");
    modalEL.find('.modal-panel').removeClass("ease-out duration-300 opacity-100 translate-y-0 sm:scale-100");

    _.delay(function (){
        modalEL.hide();
    }, 300);
}